var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 127,
    height: 152,
    viewBox: "0 0 127 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M94.3757 44.0781C94.3757 44.0781 98.4376 104.42 61.8858 104.42C25.3353 104.42 28.2689 44.0781 28.2689 44.0781C28.2689 44.0781 26.5034 8.19313 63.1246 8.19313C97.2073 8.19313 94.3757 44.0781 94.3757 44.0781Z",
    fill: "white",
    stroke: "#1A1A1A",
    strokeWidth: 1.61269,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3654 55.9852C94.3654 55.9852 97.7874 51.0481 101.847 53.4432C105.907 55.8368 104.614 64.6767 101.847 69.098C99.0786 73.5179 94.6104 75.7024 92.1398 72.3084",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M94.3654 55.9852C94.3654 55.9852 97.7874 51.0481 101.847 53.4432C105.907 55.8368 104.614 64.6767 101.847 69.098C99.0786 73.5179 94.6104 75.7024 92.1398 72.3084",
    stroke: "#1A1A1A",
    strokeWidth: 1.61269,
    strokeMiterlimit: 10
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M101.402 58.9687C101.402 58.9687 96.8277 57.4454 93.5813 64.1686",
    stroke: "#1A1A1A",
    strokeWidth: 0.807051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M95.8019 60.879C95.8019 60.879 100.78 63.5369 97.4909 67.5301",
    stroke: "#1A1A1A",
    strokeWidth: 0.807051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5137 55.9852C28.5137 55.9852 25.0917 51.0481 21.0326 53.4432C16.9735 55.8368 18.2647 64.6767 21.0326 69.098C23.8005 73.5179 28.2688 75.7024 30.7408 72.3084",
    fill: "white"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M28.5137 55.9852C28.5137 55.9852 25.0917 51.0481 21.0326 53.4432C16.9735 55.8368 18.2647 64.6767 21.0326 69.098C23.8005 73.5179 28.2688 75.7024 30.7408 72.3084",
    stroke: "#1A1A1A",
    strokeWidth: 1.61269,
    strokeMiterlimit: 10
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M21.4769 58.9687C21.4769 58.9687 26.0514 57.4454 29.2993 64.1686",
    stroke: "#1A1A1A",
    strokeWidth: 0.807051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M27.078 60.879C27.078 60.879 22.1 63.5369 25.3889 67.5301",
    stroke: "#1A1A1A",
    strokeWidth: 0.807051,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M59.7314 54.8489V67.4996C59.7314 67.8924 59.8079 68.2697 59.9466 68.6159C60.4903 69.9738 62.0562 70.6238 63.472 70.2479L66.516 69.4397",
    stroke: "#1A1A1A",
    strokeWidth: 1.52662,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M56.8133 34.7899C56.5486 35.1855 54.96 40.2031 54.96 40.2031H37.4989L43.4269 36.8486C44.929 36.0983 46.5615 35.6419 48.2364 35.502L56.8133 34.7899Z",
    fill: "#1A1A1A"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M67.8203 34.7899C68.0851 35.1855 69.6736 40.2031 69.6736 40.2031H87.1347L81.2068 36.8486C79.7046 36.0983 78.0722 35.6419 76.3973 35.502L67.8203 34.7899Z",
    fill: "#1A1A1A"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M51.0761 52.0993C51.0761 53.7695 49.7197 55.1246 48.0448 55.1246C46.3714 55.1246 45.015 53.7695 45.015 52.0993C45.015 50.4291 46.3714 49.074 48.0448 49.074C49.7197 49.074 51.0761 50.4291 51.0761 52.0993Z",
    fill: "#1A1A1A"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M79.3183 52.0993C79.3183 53.7695 77.9619 55.1246 76.287 55.1246C74.6135 55.1246 73.2572 53.7695 73.2572 52.0993C73.2572 50.4291 74.6135 49.074 76.287 49.074C77.9619 49.074 79.3183 50.4291 79.3183 52.0993Z",
    fill: "#1A1A1A"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M51.903 76.4712C51.903 76.4712 56.8823 79.9402 62.9151 79.9402C68.9492 79.9402 73.1174 76.4712 73.1174 76.4712",
    stroke: "#1A1A1A",
    strokeWidth: 1.52662,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7722 52.8886C57.7722 59.8944 52.0806 65.5747 45.0611 65.5747C38.0415 65.5747 32.35 59.8944 32.35 52.8886C32.35 45.8829 38.0415 40.2026 45.0611 40.2026C52.0806 40.2026 57.7722 45.8829 57.7722 52.8886Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.754846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M88.9986 52.8886C88.9986 59.8944 83.3071 65.5747 76.2875 65.5747C69.2665 65.5747 63.5764 59.8944 63.5764 52.8886C63.5764 45.8829 69.2665 40.2026 76.2875 40.2026C83.3071 40.2026 88.9986 45.8829 88.9986 52.8886Z",
    stroke: "#1A1A1A",
    strokeWidth: 0.754846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M57.7722 52.8886C57.7722 52.8886 60.7836 50.0838 63.577 52.8886",
    stroke: "#1A1A1A",
    strokeWidth: 0.754846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M32.8304 56.3061L28.3466 52.7877",
    stroke: "#1A1A1A",
    strokeWidth: 0.754846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M88.5432 56.3061L94.5108 51.6233",
    stroke: "#1A1A1A",
    strokeWidth: 0.754846,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M61.3088 0.900177C16.7846 0.900177 21.2812 31.1416 28.053 55.1248C28.053 55.1248 34.0772 43.9435 32.8781 36.0547C58.1714 33.1806 80.8498 19.2708 80.963 19.2016C82.7116 32.987 94.6652 53.456 94.6652 53.456C101.402 31.1416 108.403 0.900177 61.3088 0.900177Z",
    fill: "#1A1A1A"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M147.038 182.195C147.038 150.608 110.442 132.132 110.442 132.132H66.5166H59.7307H15.8053C15.8053 132.132 -20.7904 150.608 -20.7904 182.195",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M147.038 182.195C147.038 150.608 110.442 132.132 110.442 132.132H66.5166H59.7307H15.8053C15.8053 132.132 -20.7904 150.608 -20.7904 182.195",
    stroke: "#1A1A1A",
    strokeWidth: 1.61269,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M135.3 152.281H-9.05127L-1.13833 144.083H127.387L135.3 152.281Z",
    fill: "black"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5471 93.994V119.359C39.5471 119.359 34.0891 128.969 15.8054 132.133H109.172C109.172 132.133 85.7575 127.265 84.0557 119.359V93.994",
    fill: "white"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M39.5471 93.994V119.359C39.5471 119.359 34.0891 128.969 15.8054 132.133H109.172C109.172 132.133 85.7575 127.265 84.0557 119.359V93.994",
    stroke: "#1A1A1A",
    strokeWidth: 1.61269,
    strokeMiterlimit: 10,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M40.038 92.6745C40.038 92.6745 46.6073 105.691 57.2358 111.736C64.9547 116.125 74.9361 114.422 80.1746 107.263C82.7868 103.69 84.7774 98.434 84.7774 90.7048C84.7774 90.7048 76.2656 101.89 63.5757 102.416C50.8873 102.942 40.038 92.6745 40.038 92.6745Z",
    fill: "#1A1A1A"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg1);
export default __webpack_public_path__ + "static/media/1.fbc0cf39608d2ee76d895837d94e58cb.svg";
export { ForwardRef as ReactComponent };